import React from 'react';
import { Link } from 'react-router';

const PageNotFound = () => (
  <div className="page">
    <div className="error-page">
      <span>4</span>
      <div className="circle warm-pink" />
      <span>4</span>
      <h3>Something went wrong. Please return to dyzio.co and report your issue.</h3>
      <Link to="https://dyzio.co">Back to main website</Link>
    </div>
  </div>
);

export default PageNotFound;



// WEBPACK FOOTER //
// ./src/components/page-not-found/index.js